import React, { useState } from "react";
import '../../Styles/Purchaseorder.css';
import { useEffect } from "react";
import ApiConfig from "../../../api/ApiConfig";
import { PostCallWithErrorResponse, simpleGetCallWithErrorResponse } from "../../../api/ApiServices";
import FormField from "../../../component/formFiedl";
import dele from '../../../assets/images/delete.svg'
import { ToastMsg } from "../../TostMsg";
import { ClipLoader } from "react-spinners";


const LineItemRow = () => {
    const fields = ['Item', 'HSN', 'Qty', 'Unit', 'Price', 'GST %', "Total"];
    const unitOptions = ['Kg', 'Litre', 'Piece'];
    const gstOptions = ['0%', '5%', '12%', '18%', '28%'];

    return (
        <div className="line-item-row">
            {fields.map((field) => (
                <div key={field} className="line-field d-flex">
                    <strong><label className="line-label">{field}</label></strong>
                    <input
                        type="text"
                        placeholder={field}
                        className="line-input"
                    />

                </div>
            ))}
        </div>
    );
};

const Sales = () => {

    const initialOrder = {
        "Id": 0,
        "SONumber": "",
        "CustomerId": "",
        "CustomerName": "",
        "BillingAddress": "",
        "SODate": "",
        "CustomerGSTIN": "",
        "ShippingAddress": "",
        "OrderType": "",
        "TotalAmount": '',
        "OrgId": 1,
        "ClientEntityId": 31,
        "EntryBy": 101,
        "IsActive": true
    }

    const initialItems = [{
        "Id": 0,
        "SOHeaderId": 0,
        "ItemId": 0,
        "ItemName": "",
        "HSN": "",
        "Qty": '',
        "Unit": "",
        "Price": '',
        "GSTPercent": '',
        "Total": '',
        "OrgId": 1,
        "ClientEntityId": 31,
        "EntryBy": 101
    }]

    const [customers, setCustomers] = useState([])
    const [orderDetails, setOrderDetails] = useState(initialOrder)
    const [errMsg, setErMsg] = useState({})
    const [items, setItems] = useState(initialItems)
    const [isValided, setIsValided] = useState(false)
    const [isLoading, setIsLoading] = useState(false)



    const getCustomers = () => {
        simpleGetCallWithErrorResponse(ApiConfig?.GET_VENOR_CUSTOMER + 'Customer').then((res) => {

            if (res?.json?.success) {
                setCustomers(res?.json?.data)
            }


        })
    }


    const handleChange = (key, value) => {

        setOrderDetails(prev => ({
            ...prev,
            [key]: value
        }))

    }

    useEffect(() => {

        getCustomers()

    }, [])

    const handleInputChange = (index, field, value) => {
        const updatedDetails = [...items];
        updatedDetails[index][field] = value;

        if (field === "Qty" || field === "Price" || field === "GSTPercent") {
            const qty = parseFloat(updatedDetails[index].Qty) || 0;
            const price = parseFloat(updatedDetails[index].Price) || 0;
            const gst = parseFloat(updatedDetails[index].GSTPercent) || 0;
            const total = qty * price + (qty * price * gst) / 100;
            updatedDetails[index].Total = Number(total.toFixed(2));
        }

        setItems(updatedDetails);
    };

    const handleSubmit = () => {

        if (isLoading) return


        let isValided = false;

        setErMsg(prev => ({
            ...prev,
            CustomerId: !orderDetails?.CustomerId ? "Please Select Customer Name" : "",
            BillingAddress: !orderDetails?.BillingAddress ? 'Please Enter Billing Address' : "",
            ShippingAddress: !orderDetails?.ShippingAddress ? "Please Enter Ship Address" : "",
            SODate: !orderDetails?.SODate ? "Please Select Date" : "",
            CustomerGSTIN: !orderDetails?.CustomerGSTIN ? 'Please Enter GST Number' : ""
        }))

        let total = 0;
        for (let item of items) {
            if (
                !item.ItemName ||
                !item.HSN ||
                !item.Qty ||
                !item.Unit ||
                !item.Price ||
                !item.GSTPercent
            ) {
                setIsValided(true);
                ToastMsg('error', 'Please fill all item fields');
                isValided = true;
                break;
            }

            total += Number(item?.Total)
        }

        console.log(orderDetails);

        if (!orderDetails?.CustomerId || !orderDetails?.BillingAddress
            || !orderDetails?.ShippingAddress || !orderDetails?.SODate ||
            !orderDetails?.CustomerGSTIN || isValided

        ) {
            return
        }
        orderDetails.TotalAmount = total

        let payload = {
            SOHeader: orderDetails,
            SODetails: items
        }

        setIsLoading(true)

        PostCallWithErrorResponse(ApiConfig?.CREATE_SALES_ORDER, JSON.stringify(payload)).then((res) => {

            if (res?.json?.success) {
                ToastMsg('success', res?.json?.message)
                setItems(initialItems)
                setOrderDetails(initialOrder)
            } else {
                ToastMsg('error', res?.json?.message)
            }
            setIsLoading(false)
            setIsValided(false)

        })

    }


    const handleAdd = () => {

        setItems(prev => ([...prev, {
            "Id": 0,
            "SOHeaderId": 0,
            "ItemId": 0,
            "ItemName": "",
            "HSN": "",
            "Qty": '',
            "Unit": "",
            "Price": '',
            "GSTPercent": '',
            "Total": '',
            "OrgId": 1,
            "ClientEntityId": 31,
            "EntryBy": 101
        }]))

    }

    const handleDelete = (index) => {

        let filt = items?.filter((_, indx) => indx != index)

        setItems(filt)

    }

    return (
        <div className="purchase-order-form">

            {/* <div className="tabs">
        {["Procurement", "Sales", "Manufacturing", "Bundling & Packing", "Inventory", "Masters"].map(tab => (
          <button key={tab} className={`tab ${tab === "Sales" ? "active" : ""}`}>
            {tab}
          </button>
        ))}
      </div> */}

            <div className="card">
                <h2>Create Sales Order</h2>
                <div className="form-grid">
                    <FormField placeholder="SO Number (Auto-generated)"
                        value={orderDetails?.SONumber}
                        valKey={'SONumber'}
                        onChange={(key, value) => handleChange(key, value)}
                        validationErr={errMsg?.SONumber}
                    />
                    <FormField type="date"
                        value={orderDetails?.SODate}
                        valKey={'SODate'}
                        onChange={(key, value) => handleChange(key, value)}
                        validationErr={errMsg?.SODate}
                    />
                    <FormField placeholder="Customer Name" type='select'
                        options={customers}
                        valueKey={'id'}
                        labelKey={"billCustName"}
                        value={orderDetails?.CustomerId}
                        valKey={'CustomerId'}
                        validationErr={errMsg?.CustomerId}
                        onChange={(key, value) => {

                            let customer = customers?.filter((cust) => cust?.id == value)[0]

                            handleChange(key, Number(value))
                            handleChange('CustomerGSTIN', customer?.billGstNo)
                            handleChange('BillingAddress', customer?.billAddr)
                            handleChange('ShippingAddress', customer?.shipAddr)
                        }}
                    />
                    <FormField placeholder="Customer GSTIN"
                        value={orderDetails?.CustomerGSTIN}
                        valKey={'CustomerGSTIN'}
                        onChange={(key, value) => handleChange(key, value)}
                        validationErr={errMsg?.CustomerGSTIN}
                    />
                    <FormField placeholder="Billing Address"
                        value={orderDetails?.BillingAddress}
                        valKey={'BillingAddress'}
                        onChange={(key, value) => handleChange(key, value)}
                        validationErr={errMsg?.BillingAddress}
                    />
                    <FormField placeholder="Shipping Address"
                        value={orderDetails?.ShippingAddress}
                        valKey={'ShippingAddress'}
                        onChange={(key, value) => handleChange(key, value)}
                        validationErr={errMsg?.ShippingAddress}
                    />
                </div>

                <div className="line-items">
                    <h3>Line Items</h3>
                    <div className="line-item-row" style={{ marginBottom: '0px' }}>
                        <div className="line-field d-flex">
                            <strong><label className="line-label">Item</label></strong>
                        </div>
                        <div className="line-field d-flex">
                            <strong><label className="line-label">HSN</label></strong>
                        </div>
                        <div className="line-field d-flex">
                            <strong><label className="line-label">QTY</label></strong>
                        </div>
                        <div className="line-field d-flex">
                            <strong><label className="line-label">UNIT</label></strong>
                        </div>
                        <div className="line-field d-flex">
                            <strong><label className="line-label">Price</label></strong>
                        </div>
                        <div className="line-field d-flex">
                            <strong><label className="line-label">GST%</label></strong>
                        </div>
                        <div className="line-field d-flex">
                            <strong><label className="line-label">Total</label></strong>
                        </div>
                        <div className="" style={{ width: "40px" }}></div>

                    </div>
                    {
                        items?.map((item, index) => {
                            return <div className="line-item-row" key={index}>
                                <div className="line-field d-flex">
                                    <input
                                        type="text"
                                        placeholder={'Item'}
                                        className="line-input"
                                        value={item?.ItemName}
                                        onChange={(e) => handleInputChange(index, 'ItemName', e.target.value)}
                                        style={isValided && !item?.ItemName ? { border: "1px solid red" } : {}}
                                    />

                                </div>
                                <div className="line-field d-flex">
                                    <input
                                        type="text"
                                        placeholder={'HSN'}
                                        className="line-input"
                                        value={item?.HSN}
                                        onChange={(e) => handleInputChange(index, 'HSN', e.target.value)}
                                        style={isValided && !item?.HSN ? { border: "1px solid red" } : {}}
                                    />

                                </div>
                                <div className="line-field d-flex">
                                    <input
                                        type="number"
                                        placeholder={'QTY'}
                                        className="line-input"
                                        value={item?.Qty}
                                        onChange={(e) => handleInputChange(index, 'Qty', Number(e.target.value) || '')}
                                        style={isValided && !item?.Qty ? { border: "1px solid red" } : {}}
                                    />

                                </div>
                                <div className="line-field d-flex">
                                    <input
                                        type="text"
                                        placeholder={'Unit'}
                                        className="line-input"
                                        value={item?.Unit}
                                        onChange={(e) => handleInputChange(index, 'Unit', e.target.value)}
                                        style={isValided && !item?.Unit ? { border: "1px solid red" } : {}}
                                    />

                                </div>
                                <div className="line-field d-flex">
                                    <input
                                        type="number"
                                        placeholder={'Price'}
                                        className="line-input"
                                        value={item?.Price}
                                        onChange={(e) => handleInputChange(index, 'Price', Number(e.target.value) || '')}
                                        style={isValided && !item?.Price ? { border: "1px solid red" } : {}}
                                    />

                                </div>
                                <div className="line-field d-flex">
                                    <input
                                        type="number"
                                        placeholder={'GST%'}
                                        className="line-input"
                                        value={item?.GSTPercent}
                                        onChange={(e) => {
                                            if (e.target.value > 100) return
                                            handleInputChange(index, 'GSTPercent', Number(e.target.value) || '')

                                        }}
                                        style={isValided && !item?.GSTPercent ? { border: "1px solid red" } : {}}
                                    />

                                </div>
                                <div className="line-field d-flex">
                                    <input
                                        type="number"
                                        placeholder={'Total'}
                                        className="line-input"
                                        value={item?.Total}
                                        disabled={true}
                                    />

                                </div>
                                <div className="" style={{ width: "40px", marginTop: '5px', cursor: "pointer" }}>
                                    {
                                        items?.length > 1 && <img src={dele} alt=""
                                            onClick={() => handleDelete(index)}
                                        />
                                    }

                                </div>

                            </div>
                        })
                    }
                    <div className="form-buttons d-flex" style={{ justifyContent: "end" }}>
                        <button className="btn submit"
                            onClick={handleAdd}
                        >Add Item</button>
                    </div>
                </div>

                <div className="form-buttons">
                    {/* <button className="btn draft">Save Draft</button> */}
                    <button className="btn submit"
                        onClick={handleSubmit}
                    >{isLoading ? <ClipLoader color="white" size='16' /> : 'Submit Sales Order'}</button>
                </div>
            </div>
        </div>
    );
};

export default Sales;
